/* unplugin-vue-components disabled */import script from "./navLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./navLeft.vue?vue&type=script&setup=true&lang=js"

import "./navLeft.vue?vue&type=style&index=0&id=3040b9ba&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3040b9ba"]])

export default __exports__